const US_GA_ID = "G-3ZKM96RKLQ";
const US_GTM_ID = "GTM-5GD3BBVH";
const US_META_PIXEL_ID = "1693542088356349";
const US_CLARITY_ID = "x0ojrhhof9";
const US_SEARCH_CONSOLE_VERIFICATION =
  "kirNaqbIT3iin2toYXfJrlmYNF3t6NzvGs6gFjsXRh0";

const SCRIPT_IDS = {
  ga: "ohyes-us-ga",
  gtm: "ohyes-us-gtm",
  meta: "ohyes-us-meta-pixel",
  clarity: "ohyes-us-clarity",
  searchConsole: "ohyes-us-search-console",
};

let gaReady = false;
let gtmReady = false;
let metaReady = false;
let clarityReady = false;
let metaPixelInitialized = false;

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function appendScript(id, src) {
  if (!isBrowser() || document.getElementById(id)) return;

  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

function ensureSearchConsoleMeta() {
  if (!isBrowser() || document.getElementById(SCRIPT_IDS.searchConsole)) {
    return;
  }

  const meta = document.createElement("meta");
  meta.id = SCRIPT_IDS.searchConsole;
  meta.name = "google-site-verification";
  meta.content = US_SEARCH_CONSOLE_VERIFICATION;
  document.head.appendChild(meta);
}

function removeSearchConsoleMeta() {
  if (!isBrowser()) return;

  const meta = document.getElementById(SCRIPT_IDS.searchConsole);
  if (meta) meta.remove();
}

function ensureGoogleAnalytics() {
  if (!isBrowser()) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!gaReady) {
    appendScript(
      SCRIPT_IDS.ga,
      `https://www.googletagmanager.com/gtag/js?id=${US_GA_ID}`,
    );
    window.gtag("js", new Date());
    gaReady = true;
  }
}

function ensureGoogleTagManager() {
  if (!isBrowser() || gtmReady) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "gtm.js",
    "gtm.start": new Date().getTime(),
  });
  appendScript(
    SCRIPT_IDS.gtm,
    `https://www.googletagmanager.com/gtm.js?id=${US_GTM_ID}`,
  );
  gtmReady = true;
}

function ensureMetaPixel() {
  if (!isBrowser()) return;

  const hadExistingFbq = !!window.fbq;

  if (!hadExistingFbq) {
    const fbq = function fbq() {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };
    window.fbq = fbq;
    window._fbq = window._fbq || fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
  }

  if (!metaReady && !hadExistingFbq) {
    appendScript(
      SCRIPT_IDS.meta,
      "https://connect.facebook.net/en_US/fbevents.js",
    );
    metaReady = true;
  } else if (hadExistingFbq) {
    metaReady = true;
  }

  if (!metaPixelInitialized) {
    window.fbq("init", US_META_PIXEL_ID);
    metaPixelInitialized = true;
  }
}

function ensureMicrosoftClarity() {
  if (!isBrowser() || clarityReady) return;

  window.clarity =
    window.clarity ||
    function clarity() {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  appendScript(SCRIPT_IDS.clarity, `https://www.clarity.ms/tag/${US_CLARITY_ID}`);
  clarityReady = true;
}

function pageUrlForRoute(route) {
  const path = route?.fullPath || window.location.pathname;
  return `${window.location.origin}${path}`;
}

function trackUsPageView(route) {
  if (!isBrowser()) return;

  const pagePath = route?.fullPath || window.location.pathname;
  const pageLocation = pageUrlForRoute(route);

  if (window.gtag) {
    window.gtag("config", US_GA_ID, {
      page_path: pagePath,
      page_location: pageLocation,
    });
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "ohyes_us_page_view",
    page_path: pagePath,
    page_location: pageLocation,
  });

  if (window.fbq) {
    window.fbq("trackSingle", US_META_PIXEL_ID, "PageView");
  }
}

export function syncUsAnalytics(route) {
  if (!isBrowser()) return;

  const isUsRoute =
    route?.meta?.location === "us" || route?.path?.startsWith("/us");

  if (!isUsRoute) {
    removeSearchConsoleMeta();
    return;
  }

  ensureSearchConsoleMeta();
  ensureGoogleTagManager();
  ensureGoogleAnalytics();
  ensureMetaPixel();
  ensureMicrosoftClarity();
  trackUsPageView(route);
}
